// source: TransactionBody.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var SystemDelete_pb = require('./SystemDelete_pb.js');
goog.object.extend(proto, SystemDelete_pb);
var SystemUndelete_pb = require('./SystemUndelete_pb.js');
goog.object.extend(proto, SystemUndelete_pb);
var Freeze_pb = require('./Freeze_pb.js');
goog.object.extend(proto, Freeze_pb);
var ContractCall_pb = require('./ContractCall_pb.js');
goog.object.extend(proto, ContractCall_pb);
var ContractCreate_pb = require('./ContractCreate_pb.js');
goog.object.extend(proto, ContractCreate_pb);
var ContractUpdate_pb = require('./ContractUpdate_pb.js');
goog.object.extend(proto, ContractUpdate_pb);
var CryptoAddLiveHash_pb = require('./CryptoAddLiveHash_pb.js');
goog.object.extend(proto, CryptoAddLiveHash_pb);
var CryptoCreate_pb = require('./CryptoCreate_pb.js');
goog.object.extend(proto, CryptoCreate_pb);
var CryptoDelete_pb = require('./CryptoDelete_pb.js');
goog.object.extend(proto, CryptoDelete_pb);
var CryptoDeleteLiveHash_pb = require('./CryptoDeleteLiveHash_pb.js');
goog.object.extend(proto, CryptoDeleteLiveHash_pb);
var CryptoTransfer_pb = require('./CryptoTransfer_pb.js');
goog.object.extend(proto, CryptoTransfer_pb);
var CryptoUpdate_pb = require('./CryptoUpdate_pb.js');
goog.object.extend(proto, CryptoUpdate_pb);
var FileAppend_pb = require('./FileAppend_pb.js');
goog.object.extend(proto, FileAppend_pb);
var FileCreate_pb = require('./FileCreate_pb.js');
goog.object.extend(proto, FileCreate_pb);
var FileDelete_pb = require('./FileDelete_pb.js');
goog.object.extend(proto, FileDelete_pb);
var FileUpdate_pb = require('./FileUpdate_pb.js');
goog.object.extend(proto, FileUpdate_pb);
var Duration_pb = require('./Duration_pb.js');
goog.object.extend(proto, Duration_pb);
var BasicTypes_pb = require('./BasicTypes_pb.js');
goog.object.extend(proto, BasicTypes_pb);
var ContractDelete_pb = require('./ContractDelete_pb.js');
goog.object.extend(proto, ContractDelete_pb);
var ConsensusCreateTopic_pb = require('./ConsensusCreateTopic_pb.js');
goog.object.extend(proto, ConsensusCreateTopic_pb);
var ConsensusUpdateTopic_pb = require('./ConsensusUpdateTopic_pb.js');
goog.object.extend(proto, ConsensusUpdateTopic_pb);
var ConsensusDeleteTopic_pb = require('./ConsensusDeleteTopic_pb.js');
goog.object.extend(proto, ConsensusDeleteTopic_pb);
var ConsensusSubmitMessage_pb = require('./ConsensusSubmitMessage_pb.js');
goog.object.extend(proto, ConsensusSubmitMessage_pb);
var UncheckedSubmit_pb = require('./UncheckedSubmit_pb.js');
goog.object.extend(proto, UncheckedSubmit_pb);
var TokenCreate_pb = require('./TokenCreate_pb.js');
goog.object.extend(proto, TokenCreate_pb);
var TokenFreezeAccount_pb = require('./TokenFreezeAccount_pb.js');
goog.object.extend(proto, TokenFreezeAccount_pb);
var TokenUnfreezeAccount_pb = require('./TokenUnfreezeAccount_pb.js');
goog.object.extend(proto, TokenUnfreezeAccount_pb);
var TokenGrantKyc_pb = require('./TokenGrantKyc_pb.js');
goog.object.extend(proto, TokenGrantKyc_pb);
var TokenRevokeKyc_pb = require('./TokenRevokeKyc_pb.js');
goog.object.extend(proto, TokenRevokeKyc_pb);
var TokenDelete_pb = require('./TokenDelete_pb.js');
goog.object.extend(proto, TokenDelete_pb);
var TokenUpdate_pb = require('./TokenUpdate_pb.js');
goog.object.extend(proto, TokenUpdate_pb);
var TokenMint_pb = require('./TokenMint_pb.js');
goog.object.extend(proto, TokenMint_pb);
var TokenBurn_pb = require('./TokenBurn_pb.js');
goog.object.extend(proto, TokenBurn_pb);
var TokenWipeAccount_pb = require('./TokenWipeAccount_pb.js');
goog.object.extend(proto, TokenWipeAccount_pb);
var TokenAssociate_pb = require('./TokenAssociate_pb.js');
goog.object.extend(proto, TokenAssociate_pb);
var TokenDissociate_pb = require('./TokenDissociate_pb.js');
goog.object.extend(proto, TokenDissociate_pb);
goog.exportSymbol('proto.proto.TransactionBody', null, global);
goog.exportSymbol('proto.proto.TransactionBody.DataCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.TransactionBody = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.proto.TransactionBody.oneofGroups_);
};
goog.inherits(proto.proto.TransactionBody, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.TransactionBody.displayName = 'proto.proto.TransactionBody';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.proto.TransactionBody.oneofGroups_ = [[7,8,9,22,10,11,12,13,14,15,16,17,18,19,20,21,23,24,25,26,27,28,29,31,32,33,34,35,36,37,38,39,40,41]];

/**
 * @enum {number}
 */
proto.proto.TransactionBody.DataCase = {
  DATA_NOT_SET: 0,
  CONTRACTCALL: 7,
  CONTRACTCREATEINSTANCE: 8,
  CONTRACTUPDATEINSTANCE: 9,
  CONTRACTDELETEINSTANCE: 22,
  CRYPTOADDLIVEHASH: 10,
  CRYPTOCREATEACCOUNT: 11,
  CRYPTODELETE: 12,
  CRYPTODELETELIVEHASH: 13,
  CRYPTOTRANSFER: 14,
  CRYPTOUPDATEACCOUNT: 15,
  FILEAPPEND: 16,
  FILECREATE: 17,
  FILEDELETE: 18,
  FILEUPDATE: 19,
  SYSTEMDELETE: 20,
  SYSTEMUNDELETE: 21,
  FREEZE: 23,
  CONSENSUSCREATETOPIC: 24,
  CONSENSUSUPDATETOPIC: 25,
  CONSENSUSDELETETOPIC: 26,
  CONSENSUSSUBMITMESSAGE: 27,
  UNCHECKEDSUBMIT: 28,
  TOKENCREATION: 29,
  TOKENFREEZE: 31,
  TOKENUNFREEZE: 32,
  TOKENGRANTKYC: 33,
  TOKENREVOKEKYC: 34,
  TOKENDELETION: 35,
  TOKENUPDATE: 36,
  TOKENMINT: 37,
  TOKENBURN: 38,
  TOKENWIPE: 39,
  TOKENASSOCIATE: 40,
  TOKENDISSOCIATE: 41
};

/**
 * @return {proto.proto.TransactionBody.DataCase}
 */
proto.proto.TransactionBody.prototype.getDataCase = function() {
  return /** @type {proto.proto.TransactionBody.DataCase} */(jspb.Message.computeOneofCase(this, proto.proto.TransactionBody.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.TransactionBody.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.TransactionBody.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.TransactionBody} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TransactionBody.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionid: (f = msg.getTransactionid()) && BasicTypes_pb.TransactionID.toObject(includeInstance, f),
    nodeaccountid: (f = msg.getNodeaccountid()) && BasicTypes_pb.AccountID.toObject(includeInstance, f),
    transactionfee: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    transactionvalidduration: (f = msg.getTransactionvalidduration()) && Duration_pb.Duration.toObject(includeInstance, f),
    generaterecord: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    memo: jspb.Message.getFieldWithDefault(msg, 6, ""),
    contractcall: (f = msg.getContractcall()) && ContractCall_pb.ContractCallTransactionBody.toObject(includeInstance, f),
    contractcreateinstance: (f = msg.getContractcreateinstance()) && ContractCreate_pb.ContractCreateTransactionBody.toObject(includeInstance, f),
    contractupdateinstance: (f = msg.getContractupdateinstance()) && ContractUpdate_pb.ContractUpdateTransactionBody.toObject(includeInstance, f),
    contractdeleteinstance: (f = msg.getContractdeleteinstance()) && ContractDelete_pb.ContractDeleteTransactionBody.toObject(includeInstance, f),
    cryptoaddlivehash: (f = msg.getCryptoaddlivehash()) && CryptoAddLiveHash_pb.CryptoAddLiveHashTransactionBody.toObject(includeInstance, f),
    cryptocreateaccount: (f = msg.getCryptocreateaccount()) && CryptoCreate_pb.CryptoCreateTransactionBody.toObject(includeInstance, f),
    cryptodelete: (f = msg.getCryptodelete()) && CryptoDelete_pb.CryptoDeleteTransactionBody.toObject(includeInstance, f),
    cryptodeletelivehash: (f = msg.getCryptodeletelivehash()) && CryptoDeleteLiveHash_pb.CryptoDeleteLiveHashTransactionBody.toObject(includeInstance, f),
    cryptotransfer: (f = msg.getCryptotransfer()) && CryptoTransfer_pb.CryptoTransferTransactionBody.toObject(includeInstance, f),
    cryptoupdateaccount: (f = msg.getCryptoupdateaccount()) && CryptoUpdate_pb.CryptoUpdateTransactionBody.toObject(includeInstance, f),
    fileappend: (f = msg.getFileappend()) && FileAppend_pb.FileAppendTransactionBody.toObject(includeInstance, f),
    filecreate: (f = msg.getFilecreate()) && FileCreate_pb.FileCreateTransactionBody.toObject(includeInstance, f),
    filedelete: (f = msg.getFiledelete()) && FileDelete_pb.FileDeleteTransactionBody.toObject(includeInstance, f),
    fileupdate: (f = msg.getFileupdate()) && FileUpdate_pb.FileUpdateTransactionBody.toObject(includeInstance, f),
    systemdelete: (f = msg.getSystemdelete()) && SystemDelete_pb.SystemDeleteTransactionBody.toObject(includeInstance, f),
    systemundelete: (f = msg.getSystemundelete()) && SystemUndelete_pb.SystemUndeleteTransactionBody.toObject(includeInstance, f),
    freeze: (f = msg.getFreeze()) && Freeze_pb.FreezeTransactionBody.toObject(includeInstance, f),
    consensuscreatetopic: (f = msg.getConsensuscreatetopic()) && ConsensusCreateTopic_pb.ConsensusCreateTopicTransactionBody.toObject(includeInstance, f),
    consensusupdatetopic: (f = msg.getConsensusupdatetopic()) && ConsensusUpdateTopic_pb.ConsensusUpdateTopicTransactionBody.toObject(includeInstance, f),
    consensusdeletetopic: (f = msg.getConsensusdeletetopic()) && ConsensusDeleteTopic_pb.ConsensusDeleteTopicTransactionBody.toObject(includeInstance, f),
    consensussubmitmessage: (f = msg.getConsensussubmitmessage()) && ConsensusSubmitMessage_pb.ConsensusSubmitMessageTransactionBody.toObject(includeInstance, f),
    uncheckedsubmit: (f = msg.getUncheckedsubmit()) && UncheckedSubmit_pb.UncheckedSubmitBody.toObject(includeInstance, f),
    tokencreation: (f = msg.getTokencreation()) && TokenCreate_pb.TokenCreateTransactionBody.toObject(includeInstance, f),
    tokenfreeze: (f = msg.getTokenfreeze()) && TokenFreezeAccount_pb.TokenFreezeAccountTransactionBody.toObject(includeInstance, f),
    tokenunfreeze: (f = msg.getTokenunfreeze()) && TokenUnfreezeAccount_pb.TokenUnfreezeAccountTransactionBody.toObject(includeInstance, f),
    tokengrantkyc: (f = msg.getTokengrantkyc()) && TokenGrantKyc_pb.TokenGrantKycTransactionBody.toObject(includeInstance, f),
    tokenrevokekyc: (f = msg.getTokenrevokekyc()) && TokenRevokeKyc_pb.TokenRevokeKycTransactionBody.toObject(includeInstance, f),
    tokendeletion: (f = msg.getTokendeletion()) && TokenDelete_pb.TokenDeleteTransactionBody.toObject(includeInstance, f),
    tokenupdate: (f = msg.getTokenupdate()) && TokenUpdate_pb.TokenUpdateTransactionBody.toObject(includeInstance, f),
    tokenmint: (f = msg.getTokenmint()) && TokenMint_pb.TokenMintTransactionBody.toObject(includeInstance, f),
    tokenburn: (f = msg.getTokenburn()) && TokenBurn_pb.TokenBurnTransactionBody.toObject(includeInstance, f),
    tokenwipe: (f = msg.getTokenwipe()) && TokenWipeAccount_pb.TokenWipeAccountTransactionBody.toObject(includeInstance, f),
    tokenassociate: (f = msg.getTokenassociate()) && TokenAssociate_pb.TokenAssociateTransactionBody.toObject(includeInstance, f),
    tokendissociate: (f = msg.getTokendissociate()) && TokenDissociate_pb.TokenDissociateTransactionBody.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.TransactionBody}
 */
proto.proto.TransactionBody.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.TransactionBody;
  return proto.proto.TransactionBody.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.TransactionBody} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.TransactionBody}
 */
proto.proto.TransactionBody.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new BasicTypes_pb.TransactionID;
      reader.readMessage(value,BasicTypes_pb.TransactionID.deserializeBinaryFromReader);
      msg.setTransactionid(value);
      break;
    case 2:
      var value = new BasicTypes_pb.AccountID;
      reader.readMessage(value,BasicTypes_pb.AccountID.deserializeBinaryFromReader);
      msg.setNodeaccountid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setTransactionfee(value);
      break;
    case 4:
      var value = new Duration_pb.Duration;
      reader.readMessage(value,Duration_pb.Duration.deserializeBinaryFromReader);
      msg.setTransactionvalidduration(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGeneraterecord(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemo(value);
      break;
    case 7:
      var value = new ContractCall_pb.ContractCallTransactionBody;
      reader.readMessage(value,ContractCall_pb.ContractCallTransactionBody.deserializeBinaryFromReader);
      msg.setContractcall(value);
      break;
    case 8:
      var value = new ContractCreate_pb.ContractCreateTransactionBody;
      reader.readMessage(value,ContractCreate_pb.ContractCreateTransactionBody.deserializeBinaryFromReader);
      msg.setContractcreateinstance(value);
      break;
    case 9:
      var value = new ContractUpdate_pb.ContractUpdateTransactionBody;
      reader.readMessage(value,ContractUpdate_pb.ContractUpdateTransactionBody.deserializeBinaryFromReader);
      msg.setContractupdateinstance(value);
      break;
    case 22:
      var value = new ContractDelete_pb.ContractDeleteTransactionBody;
      reader.readMessage(value,ContractDelete_pb.ContractDeleteTransactionBody.deserializeBinaryFromReader);
      msg.setContractdeleteinstance(value);
      break;
    case 10:
      var value = new CryptoAddLiveHash_pb.CryptoAddLiveHashTransactionBody;
      reader.readMessage(value,CryptoAddLiveHash_pb.CryptoAddLiveHashTransactionBody.deserializeBinaryFromReader);
      msg.setCryptoaddlivehash(value);
      break;
    case 11:
      var value = new CryptoCreate_pb.CryptoCreateTransactionBody;
      reader.readMessage(value,CryptoCreate_pb.CryptoCreateTransactionBody.deserializeBinaryFromReader);
      msg.setCryptocreateaccount(value);
      break;
    case 12:
      var value = new CryptoDelete_pb.CryptoDeleteTransactionBody;
      reader.readMessage(value,CryptoDelete_pb.CryptoDeleteTransactionBody.deserializeBinaryFromReader);
      msg.setCryptodelete(value);
      break;
    case 13:
      var value = new CryptoDeleteLiveHash_pb.CryptoDeleteLiveHashTransactionBody;
      reader.readMessage(value,CryptoDeleteLiveHash_pb.CryptoDeleteLiveHashTransactionBody.deserializeBinaryFromReader);
      msg.setCryptodeletelivehash(value);
      break;
    case 14:
      var value = new CryptoTransfer_pb.CryptoTransferTransactionBody;
      reader.readMessage(value,CryptoTransfer_pb.CryptoTransferTransactionBody.deserializeBinaryFromReader);
      msg.setCryptotransfer(value);
      break;
    case 15:
      var value = new CryptoUpdate_pb.CryptoUpdateTransactionBody;
      reader.readMessage(value,CryptoUpdate_pb.CryptoUpdateTransactionBody.deserializeBinaryFromReader);
      msg.setCryptoupdateaccount(value);
      break;
    case 16:
      var value = new FileAppend_pb.FileAppendTransactionBody;
      reader.readMessage(value,FileAppend_pb.FileAppendTransactionBody.deserializeBinaryFromReader);
      msg.setFileappend(value);
      break;
    case 17:
      var value = new FileCreate_pb.FileCreateTransactionBody;
      reader.readMessage(value,FileCreate_pb.FileCreateTransactionBody.deserializeBinaryFromReader);
      msg.setFilecreate(value);
      break;
    case 18:
      var value = new FileDelete_pb.FileDeleteTransactionBody;
      reader.readMessage(value,FileDelete_pb.FileDeleteTransactionBody.deserializeBinaryFromReader);
      msg.setFiledelete(value);
      break;
    case 19:
      var value = new FileUpdate_pb.FileUpdateTransactionBody;
      reader.readMessage(value,FileUpdate_pb.FileUpdateTransactionBody.deserializeBinaryFromReader);
      msg.setFileupdate(value);
      break;
    case 20:
      var value = new SystemDelete_pb.SystemDeleteTransactionBody;
      reader.readMessage(value,SystemDelete_pb.SystemDeleteTransactionBody.deserializeBinaryFromReader);
      msg.setSystemdelete(value);
      break;
    case 21:
      var value = new SystemUndelete_pb.SystemUndeleteTransactionBody;
      reader.readMessage(value,SystemUndelete_pb.SystemUndeleteTransactionBody.deserializeBinaryFromReader);
      msg.setSystemundelete(value);
      break;
    case 23:
      var value = new Freeze_pb.FreezeTransactionBody;
      reader.readMessage(value,Freeze_pb.FreezeTransactionBody.deserializeBinaryFromReader);
      msg.setFreeze(value);
      break;
    case 24:
      var value = new ConsensusCreateTopic_pb.ConsensusCreateTopicTransactionBody;
      reader.readMessage(value,ConsensusCreateTopic_pb.ConsensusCreateTopicTransactionBody.deserializeBinaryFromReader);
      msg.setConsensuscreatetopic(value);
      break;
    case 25:
      var value = new ConsensusUpdateTopic_pb.ConsensusUpdateTopicTransactionBody;
      reader.readMessage(value,ConsensusUpdateTopic_pb.ConsensusUpdateTopicTransactionBody.deserializeBinaryFromReader);
      msg.setConsensusupdatetopic(value);
      break;
    case 26:
      var value = new ConsensusDeleteTopic_pb.ConsensusDeleteTopicTransactionBody;
      reader.readMessage(value,ConsensusDeleteTopic_pb.ConsensusDeleteTopicTransactionBody.deserializeBinaryFromReader);
      msg.setConsensusdeletetopic(value);
      break;
    case 27:
      var value = new ConsensusSubmitMessage_pb.ConsensusSubmitMessageTransactionBody;
      reader.readMessage(value,ConsensusSubmitMessage_pb.ConsensusSubmitMessageTransactionBody.deserializeBinaryFromReader);
      msg.setConsensussubmitmessage(value);
      break;
    case 28:
      var value = new UncheckedSubmit_pb.UncheckedSubmitBody;
      reader.readMessage(value,UncheckedSubmit_pb.UncheckedSubmitBody.deserializeBinaryFromReader);
      msg.setUncheckedsubmit(value);
      break;
    case 29:
      var value = new TokenCreate_pb.TokenCreateTransactionBody;
      reader.readMessage(value,TokenCreate_pb.TokenCreateTransactionBody.deserializeBinaryFromReader);
      msg.setTokencreation(value);
      break;
    case 31:
      var value = new TokenFreezeAccount_pb.TokenFreezeAccountTransactionBody;
      reader.readMessage(value,TokenFreezeAccount_pb.TokenFreezeAccountTransactionBody.deserializeBinaryFromReader);
      msg.setTokenfreeze(value);
      break;
    case 32:
      var value = new TokenUnfreezeAccount_pb.TokenUnfreezeAccountTransactionBody;
      reader.readMessage(value,TokenUnfreezeAccount_pb.TokenUnfreezeAccountTransactionBody.deserializeBinaryFromReader);
      msg.setTokenunfreeze(value);
      break;
    case 33:
      var value = new TokenGrantKyc_pb.TokenGrantKycTransactionBody;
      reader.readMessage(value,TokenGrantKyc_pb.TokenGrantKycTransactionBody.deserializeBinaryFromReader);
      msg.setTokengrantkyc(value);
      break;
    case 34:
      var value = new TokenRevokeKyc_pb.TokenRevokeKycTransactionBody;
      reader.readMessage(value,TokenRevokeKyc_pb.TokenRevokeKycTransactionBody.deserializeBinaryFromReader);
      msg.setTokenrevokekyc(value);
      break;
    case 35:
      var value = new TokenDelete_pb.TokenDeleteTransactionBody;
      reader.readMessage(value,TokenDelete_pb.TokenDeleteTransactionBody.deserializeBinaryFromReader);
      msg.setTokendeletion(value);
      break;
    case 36:
      var value = new TokenUpdate_pb.TokenUpdateTransactionBody;
      reader.readMessage(value,TokenUpdate_pb.TokenUpdateTransactionBody.deserializeBinaryFromReader);
      msg.setTokenupdate(value);
      break;
    case 37:
      var value = new TokenMint_pb.TokenMintTransactionBody;
      reader.readMessage(value,TokenMint_pb.TokenMintTransactionBody.deserializeBinaryFromReader);
      msg.setTokenmint(value);
      break;
    case 38:
      var value = new TokenBurn_pb.TokenBurnTransactionBody;
      reader.readMessage(value,TokenBurn_pb.TokenBurnTransactionBody.deserializeBinaryFromReader);
      msg.setTokenburn(value);
      break;
    case 39:
      var value = new TokenWipeAccount_pb.TokenWipeAccountTransactionBody;
      reader.readMessage(value,TokenWipeAccount_pb.TokenWipeAccountTransactionBody.deserializeBinaryFromReader);
      msg.setTokenwipe(value);
      break;
    case 40:
      var value = new TokenAssociate_pb.TokenAssociateTransactionBody;
      reader.readMessage(value,TokenAssociate_pb.TokenAssociateTransactionBody.deserializeBinaryFromReader);
      msg.setTokenassociate(value);
      break;
    case 41:
      var value = new TokenDissociate_pb.TokenDissociateTransactionBody;
      reader.readMessage(value,TokenDissociate_pb.TokenDissociateTransactionBody.deserializeBinaryFromReader);
      msg.setTokendissociate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.TransactionBody.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.TransactionBody.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.TransactionBody} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.TransactionBody.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      BasicTypes_pb.TransactionID.serializeBinaryToWriter
    );
  }
  f = message.getNodeaccountid();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      BasicTypes_pb.AccountID.serializeBinaryToWriter
    );
  }
  f = message.getTransactionfee();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
  f = message.getTransactionvalidduration();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      Duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getGeneraterecord();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getMemo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getContractcall();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      ContractCall_pb.ContractCallTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getContractcreateinstance();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      ContractCreate_pb.ContractCreateTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getContractupdateinstance();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      ContractUpdate_pb.ContractUpdateTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getContractdeleteinstance();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      ContractDelete_pb.ContractDeleteTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getCryptoaddlivehash();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      CryptoAddLiveHash_pb.CryptoAddLiveHashTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getCryptocreateaccount();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      CryptoCreate_pb.CryptoCreateTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getCryptodelete();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      CryptoDelete_pb.CryptoDeleteTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getCryptodeletelivehash();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      CryptoDeleteLiveHash_pb.CryptoDeleteLiveHashTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getCryptotransfer();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      CryptoTransfer_pb.CryptoTransferTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getCryptoupdateaccount();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      CryptoUpdate_pb.CryptoUpdateTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getFileappend();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      FileAppend_pb.FileAppendTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getFilecreate();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      FileCreate_pb.FileCreateTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getFiledelete();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      FileDelete_pb.FileDeleteTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getFileupdate();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      FileUpdate_pb.FileUpdateTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getSystemdelete();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      SystemDelete_pb.SystemDeleteTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getSystemundelete();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      SystemUndelete_pb.SystemUndeleteTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getFreeze();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      Freeze_pb.FreezeTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getConsensuscreatetopic();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      ConsensusCreateTopic_pb.ConsensusCreateTopicTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getConsensusupdatetopic();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      ConsensusUpdateTopic_pb.ConsensusUpdateTopicTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getConsensusdeletetopic();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      ConsensusDeleteTopic_pb.ConsensusDeleteTopicTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getConsensussubmitmessage();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      ConsensusSubmitMessage_pb.ConsensusSubmitMessageTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getUncheckedsubmit();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      UncheckedSubmit_pb.UncheckedSubmitBody.serializeBinaryToWriter
    );
  }
  f = message.getTokencreation();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      TokenCreate_pb.TokenCreateTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getTokenfreeze();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      TokenFreezeAccount_pb.TokenFreezeAccountTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getTokenunfreeze();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      TokenUnfreezeAccount_pb.TokenUnfreezeAccountTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getTokengrantkyc();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      TokenGrantKyc_pb.TokenGrantKycTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getTokenrevokekyc();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      TokenRevokeKyc_pb.TokenRevokeKycTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getTokendeletion();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      TokenDelete_pb.TokenDeleteTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getTokenupdate();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      TokenUpdate_pb.TokenUpdateTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getTokenmint();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      TokenMint_pb.TokenMintTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getTokenburn();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      TokenBurn_pb.TokenBurnTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getTokenwipe();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      TokenWipeAccount_pb.TokenWipeAccountTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getTokenassociate();
  if (f != null) {
    writer.writeMessage(
      40,
      f,
      TokenAssociate_pb.TokenAssociateTransactionBody.serializeBinaryToWriter
    );
  }
  f = message.getTokendissociate();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      TokenDissociate_pb.TokenDissociateTransactionBody.serializeBinaryToWriter
    );
  }
};


/**
 * optional TransactionID transactionID = 1;
 * @return {?proto.proto.TransactionID}
 */
proto.proto.TransactionBody.prototype.getTransactionid = function() {
  return /** @type{?proto.proto.TransactionID} */ (
    jspb.Message.getWrapperField(this, BasicTypes_pb.TransactionID, 1));
};


/**
 * @param {?proto.proto.TransactionID|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTransactionid = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTransactionid = function() {
  return this.setTransactionid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTransactionid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AccountID nodeAccountID = 2;
 * @return {?proto.proto.AccountID}
 */
proto.proto.TransactionBody.prototype.getNodeaccountid = function() {
  return /** @type{?proto.proto.AccountID} */ (
    jspb.Message.getWrapperField(this, BasicTypes_pb.AccountID, 2));
};


/**
 * @param {?proto.proto.AccountID|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setNodeaccountid = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearNodeaccountid = function() {
  return this.setNodeaccountid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasNodeaccountid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint64 transactionFee = 3;
 * @return {string}
 */
proto.proto.TransactionBody.prototype.getTransactionfee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.setTransactionfee = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional Duration transactionValidDuration = 4;
 * @return {?proto.proto.Duration}
 */
proto.proto.TransactionBody.prototype.getTransactionvalidduration = function() {
  return /** @type{?proto.proto.Duration} */ (
    jspb.Message.getWrapperField(this, Duration_pb.Duration, 4));
};


/**
 * @param {?proto.proto.Duration|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTransactionvalidduration = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTransactionvalidduration = function() {
  return this.setTransactionvalidduration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTransactionvalidduration = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool generateRecord = 5;
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.getGeneraterecord = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.setGeneraterecord = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string memo = 6;
 * @return {string}
 */
proto.proto.TransactionBody.prototype.getMemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.setMemo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional ContractCallTransactionBody contractCall = 7;
 * @return {?proto.proto.ContractCallTransactionBody}
 */
proto.proto.TransactionBody.prototype.getContractcall = function() {
  return /** @type{?proto.proto.ContractCallTransactionBody} */ (
    jspb.Message.getWrapperField(this, ContractCall_pb.ContractCallTransactionBody, 7));
};


/**
 * @param {?proto.proto.ContractCallTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setContractcall = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearContractcall = function() {
  return this.setContractcall(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasContractcall = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional ContractCreateTransactionBody contractCreateInstance = 8;
 * @return {?proto.proto.ContractCreateTransactionBody}
 */
proto.proto.TransactionBody.prototype.getContractcreateinstance = function() {
  return /** @type{?proto.proto.ContractCreateTransactionBody} */ (
    jspb.Message.getWrapperField(this, ContractCreate_pb.ContractCreateTransactionBody, 8));
};


/**
 * @param {?proto.proto.ContractCreateTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setContractcreateinstance = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearContractcreateinstance = function() {
  return this.setContractcreateinstance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasContractcreateinstance = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ContractUpdateTransactionBody contractUpdateInstance = 9;
 * @return {?proto.proto.ContractUpdateTransactionBody}
 */
proto.proto.TransactionBody.prototype.getContractupdateinstance = function() {
  return /** @type{?proto.proto.ContractUpdateTransactionBody} */ (
    jspb.Message.getWrapperField(this, ContractUpdate_pb.ContractUpdateTransactionBody, 9));
};


/**
 * @param {?proto.proto.ContractUpdateTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setContractupdateinstance = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearContractupdateinstance = function() {
  return this.setContractupdateinstance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasContractupdateinstance = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ContractDeleteTransactionBody contractDeleteInstance = 22;
 * @return {?proto.proto.ContractDeleteTransactionBody}
 */
proto.proto.TransactionBody.prototype.getContractdeleteinstance = function() {
  return /** @type{?proto.proto.ContractDeleteTransactionBody} */ (
    jspb.Message.getWrapperField(this, ContractDelete_pb.ContractDeleteTransactionBody, 22));
};


/**
 * @param {?proto.proto.ContractDeleteTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setContractdeleteinstance = function(value) {
  return jspb.Message.setOneofWrapperField(this, 22, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearContractdeleteinstance = function() {
  return this.setContractdeleteinstance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasContractdeleteinstance = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional CryptoAddLiveHashTransactionBody cryptoAddLiveHash = 10;
 * @return {?proto.proto.CryptoAddLiveHashTransactionBody}
 */
proto.proto.TransactionBody.prototype.getCryptoaddlivehash = function() {
  return /** @type{?proto.proto.CryptoAddLiveHashTransactionBody} */ (
    jspb.Message.getWrapperField(this, CryptoAddLiveHash_pb.CryptoAddLiveHashTransactionBody, 10));
};


/**
 * @param {?proto.proto.CryptoAddLiveHashTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setCryptoaddlivehash = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearCryptoaddlivehash = function() {
  return this.setCryptoaddlivehash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasCryptoaddlivehash = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional CryptoCreateTransactionBody cryptoCreateAccount = 11;
 * @return {?proto.proto.CryptoCreateTransactionBody}
 */
proto.proto.TransactionBody.prototype.getCryptocreateaccount = function() {
  return /** @type{?proto.proto.CryptoCreateTransactionBody} */ (
    jspb.Message.getWrapperField(this, CryptoCreate_pb.CryptoCreateTransactionBody, 11));
};


/**
 * @param {?proto.proto.CryptoCreateTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setCryptocreateaccount = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearCryptocreateaccount = function() {
  return this.setCryptocreateaccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasCryptocreateaccount = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional CryptoDeleteTransactionBody cryptoDelete = 12;
 * @return {?proto.proto.CryptoDeleteTransactionBody}
 */
proto.proto.TransactionBody.prototype.getCryptodelete = function() {
  return /** @type{?proto.proto.CryptoDeleteTransactionBody} */ (
    jspb.Message.getWrapperField(this, CryptoDelete_pb.CryptoDeleteTransactionBody, 12));
};


/**
 * @param {?proto.proto.CryptoDeleteTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setCryptodelete = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearCryptodelete = function() {
  return this.setCryptodelete(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasCryptodelete = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional CryptoDeleteLiveHashTransactionBody cryptoDeleteLiveHash = 13;
 * @return {?proto.proto.CryptoDeleteLiveHashTransactionBody}
 */
proto.proto.TransactionBody.prototype.getCryptodeletelivehash = function() {
  return /** @type{?proto.proto.CryptoDeleteLiveHashTransactionBody} */ (
    jspb.Message.getWrapperField(this, CryptoDeleteLiveHash_pb.CryptoDeleteLiveHashTransactionBody, 13));
};


/**
 * @param {?proto.proto.CryptoDeleteLiveHashTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setCryptodeletelivehash = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearCryptodeletelivehash = function() {
  return this.setCryptodeletelivehash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasCryptodeletelivehash = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional CryptoTransferTransactionBody cryptoTransfer = 14;
 * @return {?proto.proto.CryptoTransferTransactionBody}
 */
proto.proto.TransactionBody.prototype.getCryptotransfer = function() {
  return /** @type{?proto.proto.CryptoTransferTransactionBody} */ (
    jspb.Message.getWrapperField(this, CryptoTransfer_pb.CryptoTransferTransactionBody, 14));
};


/**
 * @param {?proto.proto.CryptoTransferTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setCryptotransfer = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearCryptotransfer = function() {
  return this.setCryptotransfer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasCryptotransfer = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional CryptoUpdateTransactionBody cryptoUpdateAccount = 15;
 * @return {?proto.proto.CryptoUpdateTransactionBody}
 */
proto.proto.TransactionBody.prototype.getCryptoupdateaccount = function() {
  return /** @type{?proto.proto.CryptoUpdateTransactionBody} */ (
    jspb.Message.getWrapperField(this, CryptoUpdate_pb.CryptoUpdateTransactionBody, 15));
};


/**
 * @param {?proto.proto.CryptoUpdateTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setCryptoupdateaccount = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearCryptoupdateaccount = function() {
  return this.setCryptoupdateaccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasCryptoupdateaccount = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional FileAppendTransactionBody fileAppend = 16;
 * @return {?proto.proto.FileAppendTransactionBody}
 */
proto.proto.TransactionBody.prototype.getFileappend = function() {
  return /** @type{?proto.proto.FileAppendTransactionBody} */ (
    jspb.Message.getWrapperField(this, FileAppend_pb.FileAppendTransactionBody, 16));
};


/**
 * @param {?proto.proto.FileAppendTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setFileappend = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearFileappend = function() {
  return this.setFileappend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasFileappend = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional FileCreateTransactionBody fileCreate = 17;
 * @return {?proto.proto.FileCreateTransactionBody}
 */
proto.proto.TransactionBody.prototype.getFilecreate = function() {
  return /** @type{?proto.proto.FileCreateTransactionBody} */ (
    jspb.Message.getWrapperField(this, FileCreate_pb.FileCreateTransactionBody, 17));
};


/**
 * @param {?proto.proto.FileCreateTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setFilecreate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 17, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearFilecreate = function() {
  return this.setFilecreate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasFilecreate = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional FileDeleteTransactionBody fileDelete = 18;
 * @return {?proto.proto.FileDeleteTransactionBody}
 */
proto.proto.TransactionBody.prototype.getFiledelete = function() {
  return /** @type{?proto.proto.FileDeleteTransactionBody} */ (
    jspb.Message.getWrapperField(this, FileDelete_pb.FileDeleteTransactionBody, 18));
};


/**
 * @param {?proto.proto.FileDeleteTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setFiledelete = function(value) {
  return jspb.Message.setOneofWrapperField(this, 18, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearFiledelete = function() {
  return this.setFiledelete(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasFiledelete = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional FileUpdateTransactionBody fileUpdate = 19;
 * @return {?proto.proto.FileUpdateTransactionBody}
 */
proto.proto.TransactionBody.prototype.getFileupdate = function() {
  return /** @type{?proto.proto.FileUpdateTransactionBody} */ (
    jspb.Message.getWrapperField(this, FileUpdate_pb.FileUpdateTransactionBody, 19));
};


/**
 * @param {?proto.proto.FileUpdateTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setFileupdate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 19, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearFileupdate = function() {
  return this.setFileupdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasFileupdate = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional SystemDeleteTransactionBody systemDelete = 20;
 * @return {?proto.proto.SystemDeleteTransactionBody}
 */
proto.proto.TransactionBody.prototype.getSystemdelete = function() {
  return /** @type{?proto.proto.SystemDeleteTransactionBody} */ (
    jspb.Message.getWrapperField(this, SystemDelete_pb.SystemDeleteTransactionBody, 20));
};


/**
 * @param {?proto.proto.SystemDeleteTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setSystemdelete = function(value) {
  return jspb.Message.setOneofWrapperField(this, 20, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearSystemdelete = function() {
  return this.setSystemdelete(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasSystemdelete = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional SystemUndeleteTransactionBody systemUndelete = 21;
 * @return {?proto.proto.SystemUndeleteTransactionBody}
 */
proto.proto.TransactionBody.prototype.getSystemundelete = function() {
  return /** @type{?proto.proto.SystemUndeleteTransactionBody} */ (
    jspb.Message.getWrapperField(this, SystemUndelete_pb.SystemUndeleteTransactionBody, 21));
};


/**
 * @param {?proto.proto.SystemUndeleteTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setSystemundelete = function(value) {
  return jspb.Message.setOneofWrapperField(this, 21, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearSystemundelete = function() {
  return this.setSystemundelete(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasSystemundelete = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional FreezeTransactionBody freeze = 23;
 * @return {?proto.proto.FreezeTransactionBody}
 */
proto.proto.TransactionBody.prototype.getFreeze = function() {
  return /** @type{?proto.proto.FreezeTransactionBody} */ (
    jspb.Message.getWrapperField(this, Freeze_pb.FreezeTransactionBody, 23));
};


/**
 * @param {?proto.proto.FreezeTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setFreeze = function(value) {
  return jspb.Message.setOneofWrapperField(this, 23, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearFreeze = function() {
  return this.setFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasFreeze = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional ConsensusCreateTopicTransactionBody consensusCreateTopic = 24;
 * @return {?proto.proto.ConsensusCreateTopicTransactionBody}
 */
proto.proto.TransactionBody.prototype.getConsensuscreatetopic = function() {
  return /** @type{?proto.proto.ConsensusCreateTopicTransactionBody} */ (
    jspb.Message.getWrapperField(this, ConsensusCreateTopic_pb.ConsensusCreateTopicTransactionBody, 24));
};


/**
 * @param {?proto.proto.ConsensusCreateTopicTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setConsensuscreatetopic = function(value) {
  return jspb.Message.setOneofWrapperField(this, 24, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearConsensuscreatetopic = function() {
  return this.setConsensuscreatetopic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasConsensuscreatetopic = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional ConsensusUpdateTopicTransactionBody consensusUpdateTopic = 25;
 * @return {?proto.proto.ConsensusUpdateTopicTransactionBody}
 */
proto.proto.TransactionBody.prototype.getConsensusupdatetopic = function() {
  return /** @type{?proto.proto.ConsensusUpdateTopicTransactionBody} */ (
    jspb.Message.getWrapperField(this, ConsensusUpdateTopic_pb.ConsensusUpdateTopicTransactionBody, 25));
};


/**
 * @param {?proto.proto.ConsensusUpdateTopicTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setConsensusupdatetopic = function(value) {
  return jspb.Message.setOneofWrapperField(this, 25, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearConsensusupdatetopic = function() {
  return this.setConsensusupdatetopic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasConsensusupdatetopic = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional ConsensusDeleteTopicTransactionBody consensusDeleteTopic = 26;
 * @return {?proto.proto.ConsensusDeleteTopicTransactionBody}
 */
proto.proto.TransactionBody.prototype.getConsensusdeletetopic = function() {
  return /** @type{?proto.proto.ConsensusDeleteTopicTransactionBody} */ (
    jspb.Message.getWrapperField(this, ConsensusDeleteTopic_pb.ConsensusDeleteTopicTransactionBody, 26));
};


/**
 * @param {?proto.proto.ConsensusDeleteTopicTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setConsensusdeletetopic = function(value) {
  return jspb.Message.setOneofWrapperField(this, 26, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearConsensusdeletetopic = function() {
  return this.setConsensusdeletetopic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasConsensusdeletetopic = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional ConsensusSubmitMessageTransactionBody consensusSubmitMessage = 27;
 * @return {?proto.proto.ConsensusSubmitMessageTransactionBody}
 */
proto.proto.TransactionBody.prototype.getConsensussubmitmessage = function() {
  return /** @type{?proto.proto.ConsensusSubmitMessageTransactionBody} */ (
    jspb.Message.getWrapperField(this, ConsensusSubmitMessage_pb.ConsensusSubmitMessageTransactionBody, 27));
};


/**
 * @param {?proto.proto.ConsensusSubmitMessageTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setConsensussubmitmessage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 27, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearConsensussubmitmessage = function() {
  return this.setConsensussubmitmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasConsensussubmitmessage = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional UncheckedSubmitBody uncheckedSubmit = 28;
 * @return {?proto.proto.UncheckedSubmitBody}
 */
proto.proto.TransactionBody.prototype.getUncheckedsubmit = function() {
  return /** @type{?proto.proto.UncheckedSubmitBody} */ (
    jspb.Message.getWrapperField(this, UncheckedSubmit_pb.UncheckedSubmitBody, 28));
};


/**
 * @param {?proto.proto.UncheckedSubmitBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setUncheckedsubmit = function(value) {
  return jspb.Message.setOneofWrapperField(this, 28, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearUncheckedsubmit = function() {
  return this.setUncheckedsubmit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasUncheckedsubmit = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional TokenCreateTransactionBody tokenCreation = 29;
 * @return {?proto.proto.TokenCreateTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokencreation = function() {
  return /** @type{?proto.proto.TokenCreateTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenCreate_pb.TokenCreateTransactionBody, 29));
};


/**
 * @param {?proto.proto.TokenCreateTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokencreation = function(value) {
  return jspb.Message.setOneofWrapperField(this, 29, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokencreation = function() {
  return this.setTokencreation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokencreation = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional TokenFreezeAccountTransactionBody tokenFreeze = 31;
 * @return {?proto.proto.TokenFreezeAccountTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokenfreeze = function() {
  return /** @type{?proto.proto.TokenFreezeAccountTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenFreezeAccount_pb.TokenFreezeAccountTransactionBody, 31));
};


/**
 * @param {?proto.proto.TokenFreezeAccountTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokenfreeze = function(value) {
  return jspb.Message.setOneofWrapperField(this, 31, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokenfreeze = function() {
  return this.setTokenfreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokenfreeze = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional TokenUnfreezeAccountTransactionBody tokenUnfreeze = 32;
 * @return {?proto.proto.TokenUnfreezeAccountTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokenunfreeze = function() {
  return /** @type{?proto.proto.TokenUnfreezeAccountTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenUnfreezeAccount_pb.TokenUnfreezeAccountTransactionBody, 32));
};


/**
 * @param {?proto.proto.TokenUnfreezeAccountTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokenunfreeze = function(value) {
  return jspb.Message.setOneofWrapperField(this, 32, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokenunfreeze = function() {
  return this.setTokenunfreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokenunfreeze = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional TokenGrantKycTransactionBody tokenGrantKyc = 33;
 * @return {?proto.proto.TokenGrantKycTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokengrantkyc = function() {
  return /** @type{?proto.proto.TokenGrantKycTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenGrantKyc_pb.TokenGrantKycTransactionBody, 33));
};


/**
 * @param {?proto.proto.TokenGrantKycTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokengrantkyc = function(value) {
  return jspb.Message.setOneofWrapperField(this, 33, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokengrantkyc = function() {
  return this.setTokengrantkyc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokengrantkyc = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional TokenRevokeKycTransactionBody tokenRevokeKyc = 34;
 * @return {?proto.proto.TokenRevokeKycTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokenrevokekyc = function() {
  return /** @type{?proto.proto.TokenRevokeKycTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenRevokeKyc_pb.TokenRevokeKycTransactionBody, 34));
};


/**
 * @param {?proto.proto.TokenRevokeKycTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokenrevokekyc = function(value) {
  return jspb.Message.setOneofWrapperField(this, 34, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokenrevokekyc = function() {
  return this.setTokenrevokekyc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokenrevokekyc = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional TokenDeleteTransactionBody tokenDeletion = 35;
 * @return {?proto.proto.TokenDeleteTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokendeletion = function() {
  return /** @type{?proto.proto.TokenDeleteTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenDelete_pb.TokenDeleteTransactionBody, 35));
};


/**
 * @param {?proto.proto.TokenDeleteTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokendeletion = function(value) {
  return jspb.Message.setOneofWrapperField(this, 35, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokendeletion = function() {
  return this.setTokendeletion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokendeletion = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional TokenUpdateTransactionBody tokenUpdate = 36;
 * @return {?proto.proto.TokenUpdateTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokenupdate = function() {
  return /** @type{?proto.proto.TokenUpdateTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenUpdate_pb.TokenUpdateTransactionBody, 36));
};


/**
 * @param {?proto.proto.TokenUpdateTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokenupdate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 36, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokenupdate = function() {
  return this.setTokenupdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokenupdate = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional TokenMintTransactionBody tokenMint = 37;
 * @return {?proto.proto.TokenMintTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokenmint = function() {
  return /** @type{?proto.proto.TokenMintTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenMint_pb.TokenMintTransactionBody, 37));
};


/**
 * @param {?proto.proto.TokenMintTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokenmint = function(value) {
  return jspb.Message.setOneofWrapperField(this, 37, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokenmint = function() {
  return this.setTokenmint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokenmint = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional TokenBurnTransactionBody tokenBurn = 38;
 * @return {?proto.proto.TokenBurnTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokenburn = function() {
  return /** @type{?proto.proto.TokenBurnTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenBurn_pb.TokenBurnTransactionBody, 38));
};


/**
 * @param {?proto.proto.TokenBurnTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokenburn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 38, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokenburn = function() {
  return this.setTokenburn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokenburn = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional TokenWipeAccountTransactionBody tokenWipe = 39;
 * @return {?proto.proto.TokenWipeAccountTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokenwipe = function() {
  return /** @type{?proto.proto.TokenWipeAccountTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenWipeAccount_pb.TokenWipeAccountTransactionBody, 39));
};


/**
 * @param {?proto.proto.TokenWipeAccountTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokenwipe = function(value) {
  return jspb.Message.setOneofWrapperField(this, 39, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokenwipe = function() {
  return this.setTokenwipe(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokenwipe = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional TokenAssociateTransactionBody tokenAssociate = 40;
 * @return {?proto.proto.TokenAssociateTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokenassociate = function() {
  return /** @type{?proto.proto.TokenAssociateTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenAssociate_pb.TokenAssociateTransactionBody, 40));
};


/**
 * @param {?proto.proto.TokenAssociateTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokenassociate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 40, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokenassociate = function() {
  return this.setTokenassociate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokenassociate = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional TokenDissociateTransactionBody tokenDissociate = 41;
 * @return {?proto.proto.TokenDissociateTransactionBody}
 */
proto.proto.TransactionBody.prototype.getTokendissociate = function() {
  return /** @type{?proto.proto.TokenDissociateTransactionBody} */ (
    jspb.Message.getWrapperField(this, TokenDissociate_pb.TokenDissociateTransactionBody, 41));
};


/**
 * @param {?proto.proto.TokenDissociateTransactionBody|undefined} value
 * @return {!proto.proto.TransactionBody} returns this
*/
proto.proto.TransactionBody.prototype.setTokendissociate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 41, proto.proto.TransactionBody.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.TransactionBody} returns this
 */
proto.proto.TransactionBody.prototype.clearTokendissociate = function() {
  return this.setTokendissociate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.TransactionBody.prototype.hasTokendissociate = function() {
  return jspb.Message.getField(this, 41) != null;
};


goog.object.extend(exports, proto.proto);
